<h3 mat-dialog-content>Zmień uczestnika</h3>
<mat-dialog-content>
	<span
		class="link-primary text-decoration-underline cursor-pointer openNonExistingParticipant"
		(click)="openParticipantDialog(data)"
		>Dodaj użytkownika spoza bazy uczestników</span
	>
	<div class="row mx-auto mt-3">
		<ng-container>
			<mat-form-field appearance="outline">
				<mat-label>Wyszukaj</mat-label>
				<input type="text" matInput [matAutocomplete]="autoUser" [formControl]="usersSelect" />
				<mat-autocomplete
					#autoUser="matAutocomplete"
					[displayWith]="displayUsersFn.bind(this)"
					(optionSelected)="selectUser($event)"
				>
					<mat-option *ngFor="let user of filteredUsers" [value]="user">
						{{ user.firstName }} {{ user.lastName
						}}<span *ngIf="user.birth"> | {{ user.birth | date: 'dd.MM.yyyy' }}</span
						><span *ngIf="user.userContacts[0]"> | {{ user.userContacts[0].phone }}</span>
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
		</ng-container>
		<button mat-raised-button color="primary" class="mt-3" (click)="submit()">Zmień</button>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button (click)="closeDialog()">Porzuć</button>
</mat-dialog-actions>
